import { Box, Button, Stack, Typography } from "@mui/material";

import SearchInput from "../../../../components/SearchInput";

import { useProductAnalyzer } from "../../../../contexts/productAnalyzerContext";
import { useSearch } from "../../../../hooks/useSearch";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "../../../../store/hooks";
import { selectExtension } from "../../../../features/extension/extension.selector";

const SearchAgain = () => {
  const [, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isExtension } = useAppSelector(selectExtension);
  const { asin, isLoading } = useProductAnalyzer();

  const getSearchRoute = (q: string) => {
    return isExtension ? `/product-analyzer/search?q=${q}` : `/search?q=${q}`;
  };

  const {
    searchValue,
    setSearchValue,
    handleSearch,
    error,
    isLoading: isSearching,
  } = useSearch({
    initialValue: asin,
    onSuccess: ({ status, q }) => {
      if (status === "multiple_products") {
        navigate(getSearchRoute(q));
      } else if (status === "single_product") {
        setSearchParams({ asin: q });
      }
    },
  });

  useEffect(() => {
    if (asin) {
      setSearchValue(asin);
    }
  }, [asin, setSearchValue]);

  return (
    <Stack padding="5px 8px" gap="8px">
      <Stack direction="row" gap="6px">
        <Box flexGrow={1}>
          <SearchInput
            placeholder="Search ASIN"
            onKeyDown={(e) => {
              if (searchValue === asin || !searchValue) {
                return;
              }

              if (e.key === "Enter") {
                handleSearch(searchValue);
              }
            }}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={() => handleSearch(searchValue)}
          disabled={searchValue === asin || !searchValue}
          loading={isLoading || isSearching}
        >
          Search
        </Button>
      </Stack>

      {!!error && (
        <Typography variant="body1">
          No results for "{searchValue}". Check the spelling, try a different
          ASIN, UPC or ISBN code.
        </Typography>
      )}
    </Stack>
  );
};

export default SearchAgain;
